import { Button } from "@/components/ui/button";
import { TOOFI_CARD_VARIANT_CLASS } from "@/lib/toofi-ux-tokens";
import { cn } from "@/lib/utils";

export type ToofiArtifactScopeFilter = "all" | "workspace" | "reader";

export function ToofiArtifactFilters({
  value,
  onChange,
}: {
  value: ToofiArtifactScopeFilter;
  onChange: (value: ToofiArtifactScopeFilter) => void;
}) {
  return (
    <div className={cn("inline-flex rounded-full p-1", TOOFI_CARD_VARIANT_CLASS.meta)}>
      {[
        { value: "all" as const, label: "All" },
        { value: "workspace" as const, label: "Workspace" },
        { value: "reader" as const, label: "Reader" },
      ].map((option) => (
        <Button
          key={option.value}
          type="button"
          variant="ghost"
          className={cn(
            "h-8 rounded-full border border-transparent px-3 text-[11px] font-semibold shadow-none transition-all duration-150",
            value === option.value
              ? "border-blue-200/80 bg-blue-50/95 text-blue-700 shadow-[0_10px_22px_rgba(37,99,235,0.08)] hover:bg-blue-100/90"
              : "text-slate-500 hover:bg-white/90 hover:text-slate-800",
          )}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}
